<template>
  <div>
    <table class="table table-information" width="100%">
      <tr>
        <td><strong>Title</strong></td>
        <td>{{ FAQcategory.title }}</td>
      </tr>
      <tr>
        <td><strong>Description</strong></td>
        <td>{{ FAQcategory.description }}</td>
      </tr>
      <tr>
        <td><strong>Moderator</strong></td>
        <td><span class="badge badge-danger">admin</span></td>
      </tr>
      <tr>
        <td><strong>Total Posts</strong></td>
        <td>{{ FAQcategory.total_posts }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
  import helpers from '@/helpers.js';
  export default {
    components: {
    },
    data: function () {
      return {
        page: 0,
      }
    },
    computed: {
      FAQcategory: function () {
        return this.$store.getters['faqcategories/FAQcategory'];
      },

      moderator: function () {
        if (typeof this.FAQcategory.moderator === 'undefined') {
          return 'unknown';
        }
        return this.FAQcategory.moderator;
      },

      posts: function () {
        return this.$store.getters['faqs/FAQs'];
      },

      totalPages: function () {
        return this.$store.getters['faqs/totalPages'];
      }
    },

    watch: {
      page: function (val) {
        this.$store.dispatch('faqs/getCategoryPosts', {
          page: val,
          category: this.$route.params.FAQcategory
        });
      }
    },
    created: function () {
      this.page = helpers.getPageQuery();
      this.$store.dispatch('faqcategories/getCategory', this.$route.params.FAQcategory);
    },
    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push('/faqcategories/' + this.$route.params.FAQcategory + '/faqs?page=' + page);
      }
    }
  }
</script>